import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MenuService } from '../menu.service';
import { MatMenuTrigger } from '@angular/material';

import { Menu } from './../menu.model';
import { ProfileService } from '../../../../pages/profile.service';
import { AdminService } from '../../../../pages/services/admin.service';
import { HttpClient } from '@angular/common/http';
import { Retail, Housing, SME, Corporate, LegalStep } from '../../../../pages/master/master-constant';

@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService, Retail, Housing, SME, Corporate, LegalStep ]
})
export class HorizontalMenuComponent implements OnInit {
  @Input('menuParentId') menuParentId;
  public menuItems:Array<any>;
  public settings: Settings;
  public userImage= '../assets/img/users/user.jpg';
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  constructor(
    public appSettings:AppSettings, 
    public menuService:MenuService, 
    public router:Router,
    private profileService: ProfileService,
    private adminService: AdminService,
    private http: HttpClient, 

    public retail:    Retail,
    public housing:   Housing,
    public sme:       SME,
    public corporate:  Corporate,
    public legalStep: LegalStep,
  ) { 
    this.settings = this.appSettings.settings;
  }

  private ggData    : any;
  private pfData    : any;
  private pfDataRaw : any;
  private smeByBank : any;
  private userName = "";
  private email = "";

  ngOnInit() {
    // this.menuItems = this.menuService.getHorizontalMenuItems();
    // this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
    this.ggData     = this.profileService.getLSGG();
    this.pfData     = this.profileService.getLSPF();
    this.pfDataRaw  = this.profileService.getLSPF_RAW();
    this.smeByBank  = this.profileService.getSMEbyBank();

    // console.log( "pfData ::::", this.pfData );
    // console.log( "pfDataRaw ::::", this.pfDataRaw );
    // console.log( "getPortHousing ::::", this.profileService.getPortHousing() );
    // console.log( "getPortSME ::::", this.profileService.getPortSME() );
    // console.log( "getPortCorporate ::::", this.profileService.getPortCorporate() );
    // console.log( "getSMEbyBank", this.profileService.getSMEbyBank());
    
    // console.log(this.ggData);

    if( this.ggData ){

      this.userImage  = <string> this.ggData["image"];
      this.userName   = <string>this.ggData["name"];
      this.email      = <string>this.ggData["email"];

      var enableReport         = false;
      var enableVariable       = false;
      var enableAdmin          = false;
      var enableApplication    = false;

      var subLvlMark = " ...";

      var horizontalMenuItems = [ 
        new Menu (1, 'Dashboard', '/',  null,   'dashboard',           null, false, 0),
      ];

      if( 
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT.ID ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT.ID ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.FIN_RPT.ID ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.AM_RPT.ID  ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.LEG_RPT.ID ] 
      ){
        enableReport = true;
      }

      if( 
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.CEIR.RIGHT.CEIR_VIEW.ID ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.PV.RIGHT.PV_VIEW.ID     ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ICIN.RIGHT.ICIN_VIEW.ID ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.BANK_RATE.RIGHT.BANKRATE_VIEW.ID ]
      ){
        enableVariable = true;
      }

      if( 
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.GROUP.ID  ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.MEMBER.ID ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.RIGHT.ID  ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.USER.ID   ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.LOG.ID    ]  ||
        this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.NOTI.ID   ]
      ){
        enableAdmin = true;
      }

      enableApplication

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.HOU.RIGHT.HOU_VIEW.ID ] ){
        horizontalMenuItems.push(new Menu (10, 'Housing',     null,                         null, 'house',       null, true, 0));
        // horizontalMenuItems.push(new Menu (101, 'Dashboard',          '/secured/housing-dashboard',null, 'dashboard',  null, false, 10));
        
        var idxHsMenu = 102;
        var portsHs   = this.profileService.getPortHousing();
        var idxHsCnt  = portsHs.length;
        
        for( var idxHs = 0 ; idxHs < idxHsCnt ; idxHs++ ){
          horizontalMenuItems.push(new Menu ( idxHsMenu++ ,  portsHs[ idxHs ] , 
            '/secured/housing' + ( idxHs + 1 ) + '/' + portsHs[ idxHs ] ,  null, 'home', null, false, 10 )); 
        }
      }

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.SME.RIGHT.SME_VIEW.ID ] ){
        //-- SME
        horizontalMenuItems.push(new Menu (11, 'SME', null, null, 'business',    null, true, 0 )); 
        var idxSmeMenu = 202;
        var portsSme   = this.profileService.getPortSME();
        var idxSmeCnt  = portsSme.length;
        var idxSme     = 0;
        
        for( var smeBank in this.smeByBank ){
          var idxBank   = idxSmeMenu++;
          var prtInBank = this.smeByBank[ smeBank ]
          horizontalMenuItems.push(new Menu (idxBank, smeBank + " ...", null, null, 'business', null, true, 11 ));
          for( var idxB in prtInBank ){          
            idxSme++;
            horizontalMenuItems.push(new Menu ( idxSmeMenu++ ,  prtInBank[ idxB ] , 
              '/secured/sme' + idxSme + '/' + prtInBank[ idxB ] ,  null, 'business', null, false, idxBank )); 
          } 
        }
        // for( var idxSme = 0 ; idxSme < idxSmeCnt ; idxSme++ ){
        //   horizontalMenuItems.push(new Menu ( idxSmeMenu++ ,  portsSme[ idxSme ] , 
        //     '/secured/sme' + ( idxSme + 1 ) + '/' + portsSme[ idxSme ] ,  null, 'business', null, false, 11 )); 
        // }
        //-- CORP
        horizontalMenuItems.push(new Menu (12, 'Corporate', null, null, 'location_city',    null, true, 0 )); 
        var idxCorpMenu = 152;
        var portsCorp   = this.profileService.getPortCorporate();
        var idxCorpCnt  = portsCorp.length;
        
        for( var idxCorp = 0 ; idxCorp < idxCorpCnt ; idxCorp++ ){
          horizontalMenuItems.push(new Menu ( idxCorpMenu++ ,  portsCorp[ idxCorp ] , 
            '/secured/corp' + ( idxCorp + 1 ) + '/' + portsCorp[ idxCorp ] ,  null, 'location_city', null, false, 12 )); 
        }
      }

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_LIST.ID ] ){
        horizontalMenuItems.push(new Menu (20, 'Collateral',  null,  null, 'home',  null, true, 0));
        horizontalMenuItems.push(new Menu (21, 'List',   '/collateral',  null, 'home',  null, false, 20));
        if( 
          this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_REDEEM.ID ]  ||
          this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_SELL.ID   ] 
        ){
          horizontalMenuItems.push(new Menu (22, "ไถ่ถอน" + subLvlMark,  null,  null, 'handshake',  null, true, 20));
          if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_REDEEM.ID ] ){
            horizontalMenuItems.push(new Menu (23, 'จ่ายเงินปิด', '/collateral/clt-redeem',  null, 'handshake',  null, false, 22));
          }
          if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_SELL.ID ] ){
            horizontalMenuItems.push(new Menu (24, 'ขายทอดตลาด', '/collateral/clt-sell',  null, 'sell',  null, false, 22));
          }
        }
        if( 
          this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_CONVERT.ID ]  ||
          this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_TO_NPA.ID  ] 
        ){
          horizontalMenuItems.push(new Menu (25, "to NPA" + subLvlMark,  null,  null, 'storefront',  null, true, 20));
          if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_CONVERT.ID ] ){
            horizontalMenuItems.push(new Menu (26, 'ตีทรัพย์ชำระหนี้', '/collateral/clt-convert',  null, 'store',  null, false, 25));
          }
          if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.COLLATERAL.RIGHT.CLT_TO_NPA.ID ] ){
            horizontalMenuItems.push(new Menu (27, 'ยกซื้อ NPA', '/collateral/clt-to-npa',  null, 'storefront',  null, false, 25));
          }
        }
      }

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.NPA.RIGHT.NPA_LIST.ID ] ){
        horizontalMenuItems.push(new Menu (28, 'NPA',  null,  null, 'cottage',  null, true, 0));
        horizontalMenuItems.push(new Menu (29, 'List', '/npa/npa-list',  null, 'cottage',  null, false, 28));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.NPA.RIGHT.NPA_TRAN.ID ] ){
          horizontalMenuItems.push(new Menu (30, 'NPA Transfer', '/npa/npa-transfer',  null, 'sync_alt',  null, false, 28));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.NPA.RIGHT.NPA_REPORT.ID ] ){
          horizontalMenuItems.push(new Menu (31, 'NPA Reports', '/npa/npa-reports',  null, 'library_books',  null, false, 28));
        }
      }

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_000.ID ] ){
        horizontalMenuItems.push(new Menu (33, 'Legal', null, null, 'policy',    null, true, 0 ));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_000.ID ] ){
          horizontalMenuItems.push(new Menu (34, 'Dashboard', '/legal/legal-dashboard', null, 'dashboard', null, false, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_001.ID ] ){
          horizontalMenuItems.push(new Menu (300, this.legalStep.step00 + subLvlMark, null , null, 'not_started',  null, true, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_001.ID ] ){
          horizontalMenuItems.push(new Menu (301, this.legalStep.step001, '/legal/l001-begin',        null, 'not_started',    null, false, 300 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_002.ID ] ){
          horizontalMenuItems.push(new Menu (302, this.legalStep.step002, '/legal/l002-notice',       null, 'mark_email_read',    null, false, 300 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_003.ID ] ){
          horizontalMenuItems.push(new Menu (303, this.legalStep.step003, '/legal/l003-right',        null, 'not_started',    null, false, 300 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_004.ID ] ){
          horizontalMenuItems.push(new Menu (304, this.legalStep.step004, '/legal/l004-right',        null, 'not_started',    null, false, 300 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_01.ID ] ){
          horizontalMenuItems.push(new Menu (310, this.legalStep.step01, '/legal/l01-normal',         null, 'width_normal',    null, false, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_02.ID ] ){
          horizontalMenuItems.push(new Menu (319, 'การดำเนินคดี' + subLvlMark, null, null, 'balance',    null, true, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_02.ID ] ){
          horizontalMenuItems.push(new Menu (320, this.legalStep.step02, '/legal/l02-case-start',     null, 'balance',    null, false, 319 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_03.ID ] ){
          horizontalMenuItems.push(new Menu (330, this.legalStep.step03, '/legal/l03-case-end',       null, 'balance',    null, false, 319 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_041.ID ] ){
          horizontalMenuItems.push(new Menu (340, this.legalStep.step041, '/legal/l041-case-extend',    null, 'balance',    null, false, 319 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_042.ID ] ){
          horizontalMenuItems.push(new Menu (341, this.legalStep.step042, '/legal/l042-case-extend',    null, 'balance',    null, false, 319 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_X.ID ] ){
          horizontalMenuItems.push(new Menu (342, this.legalStep.stepX, '/legal/lx-owner',         null, 'settings_accessibility',    null, false, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_05.ID ] ){
          horizontalMenuItems.push(new Menu (349, 'การบังคับคดี' + subLvlMark, null, null, 'gavel',    null, true, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_05.ID ] ){
          horizontalMenuItems.push(new Menu (350, this.legalStep.step05, '/legal/l05-case-force',     null, 'gavel',    null, false, 349 ));  
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_06.ID ] ){
          horizontalMenuItems.push(new Menu (360, this.legalStep.step06, '/legal/l06-sell',           null, 'storefront',    null, false, 349 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_07.ID ] ){
          horizontalMenuItems.push(new Menu (370, this.legalStep.step07, '/legal/l07-sold',           null, 'sell',    null, false, 349 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_08.ID ] ){
          horizontalMenuItems.push(new Menu (380, this.legalStep.step08, '/legal/l08-received',       null, 'money',    null, false, 349 ));  
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_09.ID ] ){
          horizontalMenuItems.push(new Menu (390, this.legalStep.step09, '/legal/l09-npa',            null, 'maps_home_work',    null, false, 33 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_10.ID ] ){
          horizontalMenuItems.push(new Menu (400, this.legalStep.step10, '/legal/l10-asset-detected', null, 'person_search',    null, false, 33 )); 
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_11.ID ] ){
          horizontalMenuItems.push(new Menu (410, this.legalStep.step11, '/legal/l11-case-loop',      null, 'add_moderator',    null, false, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_12.ID ] ){
          horizontalMenuItems.push(new Menu (420, this.legalStep.step12, '/legal/l12-close-account',  null, 'credit_score',    null, false, 33 ));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.LEGAL.RIGHT.LEGAL_NOTE.ID ] ){
          horizontalMenuItems.push(new Menu (430, "Legal notes", '/legal/l-note',  null, 'note_alt',    null, false, 33 ));
        }
      }//-- END : Legal menu
      
        
      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.TTB.RIGHT.TTB_VIEW.ID ] ){

        horizontalMenuItems.push(new Menu (500,'Financial',  null,   null,  'monetization_on',  null, true,  0));
        horizontalMenuItems.push(new Menu (510,'Bank Statement' + subLvlMark, null, null,  'receipt_long',  null, true,  500));


        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.TTB.RIGHT.TTB_IMP.ID ] ){
          horizontalMenuItems.push(new Menu (511,'Import', '/ttb/ttb-import', null, 'cloud_upload', null, false, 510));
        }
        horizontalMenuItems.push(new Menu (512,'Transaction List', '/ttb/ttb-list',  null, 'format_list_bulleted', null, false, 510));
        // horizontalMenuItems.push(new Menu (530,'2565', '/ttb/ttb-list-2/2022',  null, 'format_list_bulleted', null, false, 510));
        // horizontalMenuItems.push(new Menu (531,'2564', '/ttb/ttb-list-1/2021',  null, 'format_list_bulleted', null, false, 510));
      
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.CHQ.RIGHT.CHQ_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (520,'Cheque', '/cheque/cheque-new', null, 'post_add', null, false, 500));
        }    

        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.CDT.RIGHT.CDT_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (530,'Money (without Cash)', '/credit/credit-new', null, 'note_add', null, false, 500));
        }

        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.IBZ.RIGHT.IBZ_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (540,'IBIZ' + subLvlMark, null,   null,  'money',  null, true,  500));
          if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.IBZ.RIGHT.IBZ_IMP.ID ] ){
              horizontalMenuItems.push(new Menu (550,'Import', '/ibiz/ibiz-import',    null, 'cloud_upload',           null, false, 540));
          }
          horizontalMenuItems.push(new Menu (560,'2564', '/ibiz/ibiz-list-4/2021',   null, 'format_list_bulleted',   null, false, 540));
          horizontalMenuItems.push(new Menu (570,'2563', '/ibiz/ibiz-list-3/2020',   null, 'format_list_bulleted',   null, false, 540));
          horizontalMenuItems.push(new Menu (580,'2562', '/ibiz/ibiz-list-2/2019',   null, 'format_list_bulleted',   null, false, 540));
          horizontalMenuItems.push(new Menu (590,'2561', '/ibiz/ibiz-list-1/2018',   null, 'format_list_bulleted',   null, false, 540));
          
        }
        
      }//-- END : Financial menu
      

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.TDR.RIGHT.TDR_VIEW.ID ] ){
        horizontalMenuItems.push(new Menu (610,'TDR',     null,   null,  'description',  null, true,  0));
        horizontalMenuItems.push(new Menu (611,'Search',  '/tdr/tdr-search',       null, 'search',          null, false, 610));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.TDR.RIGHT.TDR_IMP.ID ] ){
          horizontalMenuItems.push(new Menu (612,'Import',  '/tdr/tdr-import',       null, 'cloud_upload',    null, false, 610));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.TDR.RIGHT.TDR_EXP.ID ] ){
          horizontalMenuItems.push(new Menu (613,'Export',  '/tdr/tdr-export',       null, 'cloud_download',  null, false, 610));
        }
      }

      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.VIEW.ID ] ){
        horizontalMenuItems.push(new Menu (620,'Request',     null,   null,  'assignment',  null, true,  0));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.WAV_DEF.ID ] ){
          horizontalMenuItems.push(new Menu (621,'Waive ผิดนัด',  '/request/request-waive-default',       null, 'assignment',  null, false, 620));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.CLS_ACC.ID ] ){
          horizontalMenuItems.push(new Menu (623,'ปิดบัญชี',  '/request/request-close-account',       null, 'assignment',  null, false, 620));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.NEW_PF.ID ] ){
          horizontalMenuItems.push(new Menu (624,'เพิ่ม Portfolio',  '/request/request-new-portfolio',       null, 'assignment',  null, false, 620));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.IMP_DT.ID ] ){
          horizontalMenuItems.push(new Menu (625,'Debtor Import',  '/request/request-import-debtor',       null, 'assignment',  null, false, 620));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.IMP_CLT.ID ] ){
          horizontalMenuItems.push(new Menu (626,'Collateral Import',  '/request/request-import-collateral',       null, 'assignment',  null, false, 620));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.REQ.RIGHT.CANCEL_RECP.ID ] ){
          horizontalMenuItems.push(new Menu (627,'ยกเลิกเลขที่ใบเสร็จ',  '/request/request-cancel-receipt',       null, 'assignment',  null, false, 620));
        }
      }
      
      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.VIEW.ID ] ){
        horizontalMenuItems.push(new Menu (630,'Approve',     null,   null,  'task_alt',  null, true,  0));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.WAV_DEF.ID ] ){
          horizontalMenuItems.push(new Menu (631,'Waive ผิดนัด',  '/approve/approve-waive-default',       null, 'task_alt',  null, false, 630));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLS_ACC.ID ] ){
          horizontalMenuItems.push(new Menu (632,'ปิดบัญชี',  '/approve/approve-close-account',       null, 'task_alt',  null, false, 630));
        }
        horizontalMenuItems.push(new Menu (633,'ไถ่ถอนหลักประกัน' + subLvlMark,     null,   null,  'task_alt',  null, true,  630));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLS_CLT.ID ] ){
          horizontalMenuItems.push(new Menu (634,'จ่ายเงินปิด',  '/approve/approve-close-collateral',       null, 'task_alt',  null, false, 633));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.SELL_CLT.ID ] ){
          horizontalMenuItems.push(new Menu (635,'ขายทอดตลาด',  '/approve/approve-sell-collateral',       null, 'task_alt',  null, false, 633));
        }
        horizontalMenuItems.push(new Menu (636,'to NPA' + subLvlMark,     null,   null,  'task_alt',  null, true,  630));
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLT_TO_MONEY.ID ] ){
          horizontalMenuItems.push(new Menu (637,'ตีทรัพย์ชำระหนี้',  '/approve/approve-clt-convert',       null, 'task_alt',  null, false, 636));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CLT_TO_NPA.ID ] ){
          horizontalMenuItems.push(new Menu (638,'ยกซื้อ NPA',  '/approve/approve-clt-to-npa',       null, 'task_alt',  null, false, 636));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.NEW_PF.ID ] ){
          horizontalMenuItems.push(new Menu (639,'เพิ่ม Portfolio',  '/approve/approve-new-portfolio',       null, 'task_alt',  null, false, 630));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.IMP_DT.ID ] ){
          horizontalMenuItems.push(new Menu (640,'Debtor Import',  '/approve/approve-import-debtor',       null, 'task_alt',  null, false, 630));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.IMP_CLT.ID ] ){
          horizontalMenuItems.push(new Menu (641,'Collateral Import',  '/approve/approve-import-collateral',       null, 'task_alt',  null, false, 630));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APPROVE.RIGHT.CANCEL_RECP.ID ] ){
          horizontalMenuItems.push(new Menu (642,'ยกเลิกเลขที่ใบเสร็จ',  '/approve/approve-cancel-receipt',       null, 'task_alt',  null, false, 630));
        }
      }


      if( enableReport ){
        horizontalMenuItems.push(new Menu (650,'Reports', null,   null,  'library_books',  null, true,  0));

        horizontalMenuItems.push(new Menu (651,'v.2562',   '/ibiz/ibiz-reports-2562',  null, 'receipt', null, false, 650));
        horizontalMenuItems.push(new Menu (652,'v.2564',   '/ibiz/ibiz-reports-2564',null, 'receipt', null, false, 650));

        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.ACC_RPT.ID ] ){
          horizontalMenuItems.push(new Menu (660,'Accounting',   '/reports/accounting-reports',null, 'receipt', null, false, 650));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT.ID ] ){
        horizontalMenuItems.push(new Menu (670,'Operation',   '/reports/operation-reports',null, 'receipt', null, false, 650));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.OPR_RPT.ID ] ){
        horizontalMenuItems.push(new Menu (671,'Operation 2024',   '/reports/operation-reports-2024',null, 'receipt', null, false, 650));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.FIN_RPT.ID ] ){
        horizontalMenuItems.push(new Menu (680,'Financial',   '/reports/financial-reports',null, 'receipt', null, false, 650));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.AM_RPT.ID ] ){
        horizontalMenuItems.push(new Menu (690,'AM',   '/reports/am-reports',null, 'receipt', null, false, 650));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.LEG_RPT.ID ] ){
        horizontalMenuItems.push(new Menu (695,'Legal',   '/reports/legal-reports',null, 'receipt', null, false, 650));
        }
        // if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.RPT.RIGHT.NPA_RPT.ID ] ){
        // horizontalMenuItems.push(new Menu (696,'NPA',   '/reports/npa-reports',null, 'receipt', null, false, 650));
        // }

      }

      
      if( enableVariable ){

        horizontalMenuItems.push(new Menu (700,'Variable', null,  null, 'settings',  null, true,  0));
      
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.CEIR.RIGHT.CEIR_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (710,'CEIR', '/variable/ceir', null, 'scatter_plot', null, false, 700));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.PV.RIGHT.PV_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (720,'PV',   '/variable/pv',  null, 'scatter_plot', null, false, 700));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ICIN.RIGHT.ICIN_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (730,'เงินลงทุนส่วนเพิ่ม', '/variable/expense', null, 'scatter_plot', null, false, 700));  
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.BANK_RATE.RIGHT.BANKRATE_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (740,'MLR, MRR', '/variable/bankrate', null, 'scatter_plot', null, false, 700));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.KCC_CEIR.RIGHT.CEIR_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (750,'KCC CEIR', '/variable/kccceir', null, 'scatter_plot', null, false, 700));  
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.KCC_PV.RIGHT.PV_VIEW.ID ] ){
          horizontalMenuItems.push(new Menu (760,'KCC PV', '/variable/kccpv', null, 'scatter_plot', null, false, 700));  
        }
      }


      if( enableAdmin ){

        horizontalMenuItems.push(new Menu (900,'Admin', null,  null, 'settings',  null, true,  0));

        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.GROUP.ID ] ){
          horizontalMenuItems.push(new Menu (910, 'User Group',   '/users/u-group',  null, 'groups',             null, false, 900));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.MEMBER.ID ] ){
          horizontalMenuItems.push(new Menu (920, 'Group Member', '/users/g-member', null, 'supervisor_account', null, false, 900));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.RIGHT.ID ] ){ 
          horizontalMenuItems.push(new Menu (930, 'Access Right', '/users/g-right',  null, 'verified_user',      null, false, 900));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.USER.ID ] ){ 
          horizontalMenuItems.push(new Menu (940, 'User',         '/users',          null, 'person',             null, false, 900));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.LOG.ID ] ){ 
          horizontalMenuItems.push(new Menu (950, 'Log',          '/users/u-log',    null, 'description',        null, false, 900));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.ADMIN.RIGHT.NOTI.ID ] ){ 
          horizontalMenuItems.push(new Menu (960, 'Notification', '/users/u-noti',   null, 'notifications',      null, false, 900));
        }

      }
      
      if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_USR.ID  ]  ||  
          this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_NOTI.ID ]  ||  
          this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_CHAT.ID ] ){

        horizontalMenuItems.push(new Menu (1000,'Application', null,  null, 'phone_iphone',  null, true,  0));

        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_USR.ID ] ){
          horizontalMenuItems.push(new Menu (1010, 'User', '/application/application-user',  null, 'group',  null, false, 1000));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_USR.ID ] ){
          horizontalMenuItems.push(new Menu (1011, 'User Group', '/application/application-group',  null, 'groups',  null, false, 1000));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_USR.ID ] ){
          horizontalMenuItems.push(new Menu (1012, 'Group Member', '/application/application-member',  null, 'group_add',  null, false, 1000));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_NOTI.ID ] ){
          horizontalMenuItems.push(new Menu (1020, 'Notification' + subLvlMark, null,  null, 'notifications',  null, true, 1000));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_NOTI.ID ] ){
          horizontalMenuItems.push(new Menu (1021, 'New', '/application/application-new-notification',  null, 'add',  null, false, 1020));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_NOTI.ID ] ){
          horizontalMenuItems.push(new Menu (1022, 'List', '/application/application-notification',  null, 'notifications',  null, false, 1020));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_CHAT.ID ] ){
          horizontalMenuItems.push(new Menu (1030, 'Chat' + subLvlMark, null,  null, 'forum',  null, true, 1000));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_CHAT.ID ] ){
          horizontalMenuItems.push(new Menu (1031, 'by Type', '/application/application-chat',  null, 'chat',  null, false, 1030));
        }
        if( this.ggData[ "U_RIGHT" ][ this.adminService.ACCESS_RIGHT.APP.RIGHT.APP_CHAT.ID ] ){
          horizontalMenuItems.push(new Menu (1032, 'by User', '/application/application-chat-user',  null, '3p',  null, false, 1030));
        }
      }

      this.menuItems =  horizontalMenuItems;
      this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
    }

  }

  ngAfterViewInit(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(this.settings.fixedHeader){
          let mainContent = document.getElementById('main-content');
          if(mainContent){
            mainContent.scrollTop = 0;
          }
        }
        else{
          document.getElementsByClassName('mat-drawer-content')[0].scrollTop = 0;
        }
      }                
    });
  } 

}